
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-1---create-react-app"}}>{`Ex. 1 - Create React App`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons créer une application de recherche de films basée sur l'`}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://developers.themoviedb.org/3"}}>{`API de TheMovieDB`}</MDXTag>{`.`}</MDXTag>
<MDXTag name="p" components={components}>{`La première étape va être la création de notre application à l'aide de l'utilitaire `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/facebook/create-react-app/"}}>{`create-react-app`}</MDXTag>{`.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Lancer la commande `}<MDXTag name="inlineCode" components={components} parentName="li">{`npx create-react-app .`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Lancer la commande `}<MDXTag name="inlineCode" components={components} parentName="li">{`npm start`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`La page de démarrage de create-react-app s'affiche.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-1/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
           </MDXTag>
  }
}
  